















import Vue from 'vue';
import { mapGetters } from 'vuex';

import AuthForm from './AuthForm.vue';

export default Vue.extend({
    name: 'AuthPanel',
    components: {
        AuthForm
    },
    computed: {
        ...mapGetters('app', {
            appName: 'getAppName'
        }),
    }
});
